// Tutorial icons and tones — shared by the `tutorial` and `tutorial-config` controllers.
// The icon keys and tone keys MUST match TutorialStep.Icon / TutorialStep.Tone in lead_shop/tour/models.
// Icons are static SVG (line, 20x20, stroke 1.75, currentColor); they are parsed with DOMParser, never innerHTML.
// Tone colours live in CSS (tour.css, [data-tone]) — here only the keys and Polish labels.

const svg = (d) =>
  `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${d}</svg>`

export const ICONS = {
  info: { label: "Informacja", svg: svg('<circle cx="12" cy="12" r="9"/><path d="M12 11v5"/><path d="M12 7.5h.01"/>') },
  filter: { label: "Filtry", svg: svg('<path d="M4 5h16l-6 7.5V19l-4-2v-4.5z"/>') },
  pin: { label: "Region", svg: svg('<path d="M12 21s-6.5-5.6-6.5-11a6.5 6.5 0 0 1 13 0C18.5 15.4 12 21 12 21z"/><circle cx="12" cy="10" r="2.3"/>') },
  cart: { label: "Koszyk", svg: svg('<path d="M3.5 4h2.2l2 11h10.1l1.9-7.5H7"/><circle cx="9.5" cy="19.5" r="1.3"/><circle cx="17" cy="19.5" r="1.3"/>') },
  eye: { label: "Podgląd", svg: svg('<path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12z"/><circle cx="12" cy="12" r="2.8"/>') },
  hand: { label: "Kliknij", svg: svg('<path d="M9 11V5.5a1.5 1.5 0 0 1 3 0V10"/><path d="M12 9.5a1.5 1.5 0 0 1 3 0V11"/><path d="M15 10.5a1.5 1.5 0 0 1 3 0V15a6 6 0 0 1-6 6h-.6a5 5 0 0 1-3.9-1.9L5 16a1.5 1.5 0 0 1 2.3-1.9L9 16"/>') },
  leaf: { label: "Spokojnie", svg: svg('<path d="M5 19c0-8 5.5-13 14-14-1 8.5-6 14-14 14z"/><path d="M5 19c3-3.5 6-6 9.5-8"/>') },
  check: { label: "Gotowe", svg: svg('<circle cx="12" cy="12" r="9"/><path d="m8.5 12.3 2.4 2.4 4.8-5"/>') },
}

export const TONES = {
  sage: { label: "Szałwia" },
  sky: { label: "Mgła" },
  sand: { label: "Piasek" },
  lilac: { label: "Lawenda" },
}

export const DEFAULT_ICON = "info"
export const DEFAULT_TONE = "sage"

// A fresh <svg> element for an icon key (unknown key → the info icon).
export function iconNode(key) {
  const source = (ICONS[key] || ICONS[DEFAULT_ICON]).svg
  const parsed = new DOMParser().parseFromString(source, "image/svg+xml").documentElement
  return document.importNode(parsed, true)
}
